import { compose, flatten, values } from "ramda";
import { parse } from "query-string";
import moment from "moment-timezone";

export const formatErrors = (errors = {}) => compose(flatten, values)(errors);

export const getDate = location => {
  const { time_start } = parse(location.search);
  return formatTime(time_start);
};

export const getCurrentBooking = (bookings, id) => {
  const item = bookings.find(item => item.id === parseInt(id, 10));
  return {
    objectives: item.call_objectives,
    date: moment(item.time_slot.time_start).format(
      "ddd, MMM Do, YYYY - h:mm A"
    ),
    resume: item.insider.resume_truncated,
    company: item.insider.company,
    duration: "30",
    price: `$${parseInt(item.order.amount, 10)}`
  };
};

export const formatTime = time =>
  `${moment(time, "YYYY-MM-DDTHH:mm:ssZ").format(
    "ddd, MMM Do, YYYY - h:mm A"
  )}, ${moment()
    .tz(moment.tz.guess())
    .format("z")}`;

export const getBookedCallById = (calls, id) =>
  calls.find(call => call.id === parseInt(id, 10));



// WEBPACK FOOTER //
// ./src/modules/booking/model.js